import React, { Component } from 'react';
import { Button } from 'antd';
import './index.css'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../core/reducers';
import { 
    actionSendCaptcha,
    actionRegister,
    actionRegisterFail,
 } from '../../../core/actions/user';
import RegisterForm from './registerForm'
import { RouteComponentProps } from 'react-router-dom';
import img_login from './img_login.png'

interface StateProps {
    registerFailData: string
}

interface DispatchProps {
    sendCaptcha(data, isRegister): void
    register(data, isIns): void
    clearError(): void
}


type PropsType = StateProps & RouteComponentProps
class Index extends Component<PropsType & DispatchProps> {
    
    goLogin = () => {
        this.props.clearError();
        const { history } = this.props;
        history.push('/merchant/login');
    }

    componentDidMount () {
        localStorage.removeItem('loginStatus');
        localStorage.removeItem('accessToken');
    }

    render () {

        return (
            <div className="mer_register">
                <div className="header">
                    <h3>SennoFeet</h3>
                    <div>
                        <Button 
                            className="margin-right-20" 
                            onClick={() => this.goLogin()}
                            >登录</Button>
                        <Button 
                            type="primary" 
                            className="btn-blue"
                            >注册</Button>
                    </div>
                </div>
                <div className="content">
                    <div className="content-left">
                        <h1>足压足型测评系统管理后台-商户端</h1>
                        <img src={img_login} className="img-login"/>
                    </div>
                    <div className="content-form">
                        <div className="register">
                            <p className="register-title">账号注册</p>
                            <RegisterForm 
                                registerFailData={this.props.registerFailData}
                                sendCaptcha={this.props.sendCaptcha}
                                register={this.props.register}
                                />
                            <p className="text-center">
                                已有账号? 
                                <a onClick={() => this.goLogin()}>立即登录</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="foot">
                    <p>Copyright © SennoFeet足压后台  2020-2050</p>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        registerFailData: state.user.registerFailData
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        sendCaptcha: (data, isRegister) => {
            dispatch(actionSendCaptcha(data, isRegister))
        },
        register: (data) => {
            dispatch(actionRegister(data, true))
        },
        clearError: () => {
            dispatch(actionRegisterFail({
                data: ''
            }))
        }
        
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index as any)